import { PuzzleTimeRecordModel } from './puzzle-time-record.model';
import { TimeRecordModel } from './time-record.model';

export class InitTimeRecord {
  static readonly type = '[PuzzleTimeRecord] Init';
  constructor(public payload: PuzzleTimeRecordModel) {
    if (!payload.timeRecord) {
      payload.timeRecord = new TimeRecordModel();
    }
  }
}

// export class SetTimeRecord {
//   static readonly type = '[PuzzleTimeRecord] Set';
//   constructor(public payload: PuzzleTimeRecordModel) {}
// }

// export class PuzzleTimeRecordMultiTabSync {
//   static readonly type = '[PuzzleTimeRecord] Sync browser tabs';
//   constructor(public payload: Array<PuzzleTimeRecordModel>) {}
// }

export class UpdateTime {
  constructor(public payload: { puzzleID: string }) {}
  static readonly type = '[PuzzleTimeRecord] Update time';
  public preventUpdate = false;
}

export class InitTime {
  constructor(public payload: { puzzleID: string }) {}
  static readonly type = '[PuzzleTimeRecord] Init time';
}
